import React from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import { Evidence } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { useLanguage } from "../../../../contexts";

const evidenceController = new Evidence();

export function EvidenceForm({ evidence, close, onReload }) {
  const { accessToken } = useAuth();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const formik = useFormik({
    initialValues: { code: evidence?.code || "", name: evidence?.name || "" },
    validationSchema: Yup.object({
      code: Yup.string().required("El código es requerido"),
      name: Yup.string().required("El nombre es requerido"),
    }),
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (evidence) {
          await evidenceController.updateEvidence(accessToken, evidence._id, values);
          toast.success(t("updated"));
        } else {
          await evidenceController.createEvidence(accessToken, values);
          toast.success(t("created"));
        }
        onReload();
        close();
      } catch (err) {
        toast.error(err?.msg || t("error"));
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit} style={{ padding: "0.5rem" }}>
      <ToastContainer position="top-center" autoClose={800} hideProgressBar />
      <Form.Input label={<label>{t("code")} <span style={{ color: "#C0392B" }}>*</span></label>} name="code" value={formik.values.code} onChange={formik.handleChange} error={formik.errors.code} placeholder="Ej: Pe" />
      <Form.Input label={<label>{t("name")} <span style={{ color: "#C0392B" }}>*</span></label>} name="name" value={formik.values.name} onChange={formik.handleChange} error={formik.errors.name} placeholder="Ej: Permiso" />
      <div style={{ display: "flex", justifyContent: "center", gap: "14px", marginTop: "2rem" }}>
        <button type="submit" disabled={formik.isSubmitting} style={{ background: "#4A7FA5", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 30px", fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer", opacity: formik.isSubmitting ? 0.55 : 1 }}>
          {formik.isSubmitting ? "…" : (evidence ? t("update") : t("save"))}
        </button>
        <button type="button" onClick={close} style={{ background: "#9BAFC4", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 30px", fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer" }}>
          {t("cancel")}
        </button>
      </div>
    </Form>
  );
}
